import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { KsefSendParametersRepositoryBase } from '@skylab-shared/business';
export { KsefSendParametersRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(KsefSendParametersRepositoryBase)
export class KsefSendParametersRepository {
	public constructor(
		weaver: Weaver,
		http: Http
	) { }
}
